export default __webpack_public_path__ + "static/media/385.60b6a5e8.gif";